import { Premise } from '../../auth/lib/auth.types'
import { PremiseTypeAlias } from '../../requests/lib/requests.types'

const orderTypeAlias = [
  PremiseTypeAlias.Flat,
  PremiseTypeAlias.Apartment,
  PremiseTypeAlias.Office
]

export const guestParkingId = '44444444-4444-4444-4444-444444444444'

export const getPremisesWithoutGuestParking = (premises: Premise[]) =>
  premises.filter(({ id }) => id !== guestParkingId)

export const getPremisesWithoutParkingPlaces = (premises: Premise[]) =>
  premises.filter(({ typeAlias }) => typeAlias !== PremiseTypeAlias.CarSpace)

const sortPremises = (a: Premise, b: Premise) => {
  const aInOrder = orderTypeAlias.includes(a.typeAlias)
  const bInOrder = orderTypeAlias.includes(b.typeAlias)

  if (aInOrder && bInOrder) {
    return (
      orderTypeAlias.indexOf(a.typeAlias) - orderTypeAlias.indexOf(b.typeAlias)
    )
  } else if (aInOrder) {
    return -1
  } else if (bInOrder) {
    return 1
  } else {
    return 0
  }
}

export const getOrderedPremises = (premises: Premise[]) => {
  return [...premises].sort(sortPremises)
}
